var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedirect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "interactive-button/reply"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.8046 7.00152C27.4406 5.54654 24.9996 6.51181 24.9996 8.50619L24.9996 15.0004C13.4017 15.0004 3.99964 24.4025 3.99964 36.0004C3.99964 36.1659 4.00156 36.331 4.00537 36.4957C4.04606 38.2512 6.15444 39.1089 7.41132 37.8947C11.1911 34.2435 16.3314 32.0004 21.9996 32.0004C23.0191 32.0004 24.0207 32.0729 24.9996 32.2128V39.4947C24.9996 41.4891 27.4406 42.4543 28.8046 40.9994L42.8175 26.0523C43.8994 24.8983 43.8994 23.1026 42.8175 21.9486L28.8046 7.00152ZM28.9996 13.058L39.2582 24.0004L28.9996 34.9429V28.9402L27.4325 28.5928C25.6816 28.2047 23.8633 28.0004 21.9996 28.0004C17.0199 28.0004 12.3783 29.4578 8.48083 31.9677C10.2914 24.5255 17.0003 19.0004 24.9996 19.0004C25.6055 19.0004 26.2033 19.032 26.7915 19.0936L28.9996 19.3246V13.058Z",
    fill: "#4E5969"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedirect);
export default __webpack_public_path__ + "static/media/redirect.b32d4c67d6af19a09e173b2022ec4bcc.svg";
export { ForwardRef as ReactComponent };